const FillerLi = () => <li className="available_columns_filler">FILLER</li>

export default FillerLi;
